<template>
  <div>
    <div class="admin">ADMIN</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Jura&display=swap');

.admin {
  font:
    small-caps 700 10px 'Jura',
    sans-serif;
  pointer-events: none;
  padding: 0 $space-x-xs;
}
</style>
